/**
 * List of events for chat
 */
export const RentalServiceEvent = {
    /**
     * Event to get availability
     */
    AVAILABILITY_SEARCH: "public.holacarrentals.bookingengine.availability.search",
    AVAILABILITY_SEARCH_RESULT: "public.holacarrentals.bookingengine.availability.search.results",
    AVAILABILITY_SEARCH_SINGLE: "public.holacarrentals.bookingengine.availability.search.single",
    AVAILABILITY_SEARCH_SINGLE_RESULT: "public.holacarrentals.bookingengine.availability.search.single.results",
    UPDATE_TASK_STATUS: "public.holacarrentals.bookingengine.availability.search.results.Complete",
    USER_ANALIZER_CAPTURE: "public.holacarrentals.useranalyzer.capture",
    USER_ANALIZER_VALIDATE: "public.holacarrentals.useranalyzer.validate",
    RESERVATION_RESULT_SUCCESS: "public.holacarrentals.bookingengine.availability.reservation.result.success",
    CHECKOUT_INTENT: "public.holacarrentals.payment.create.intent",
    CHECKOUT_INTENT_RESULT: "public.holacarrentals.payment.create.intent.result",
    CHECKOUT_INTENT_PAYPAL: "public.holacarrentals.payment.paypal.create.order",
    CHECKOUT_INTENT_RESULT_PAYPAL: "public.holacarrentals.payment.paypal.create.order.result",
    AVAILABILITY_GET_FILTERS: "public.holacarrentals.bookingengine.availability.filter",
    CAPTURE_ORDER_PAYPAL: "public.holacarrentals.payment.paypal.capture.order",
    UPDATE_OFFER_STATUS: "public.holacarrentals.bookingengine.availability.offer.status.update",
    PAYMENT_COMPLETE: "public.holacarrentals.checkout.payment.on_destination.complete",
    AVAILABILITY_SEARCH_SINGLE_PAYMENT: "public.holacarrentals.order.reservation.search.single",
    AVAILABILITY_SEARCH_SINGLE_PAYMENT_RESULT: "public.holacarrentals.order.reservation.search.result",
    PAYMENT_STATUS: "public.holacarrentals.payment.retrieve.intent",
    PAYMENT_STATUS_RESULT: "public.holacarrentals.payment.retrieve.intent.result",
    LOCATIONS_RESULTS: "public.holacarrentals.bookingengine.availability.locations.search.results.Complete",
    ESIM_VALIDATE_REQUEST: "public.holacarrentals.holafly.esim.validate.request",
    ESIM_VALIDATE_RESULT: "public.holacarrentals.holafly.esim.validate.result",
    BABY_SEAT_QUOTATION_REQUEST: "public.holacarrentals.bookingengine.availability.babyseat.quotation.request",
    BABY_SEAT_QUOTATION_RESULT: "public.holacarrentals.bookingengine.availability.babyseat.quotation.results",
    DEVICE_REGISTER: "public.holacarrentals.security.device.register"
};
